// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__0EYq4","updated":"Badge_updated__LyCY8","new":"Badge_new__bWnmr"};